<template>
    <app-dialog :title="tnTitle(notification.title)" :subtitle="tnSubtitle(notification.subtitle)" v-bind="$attrs" @input="onDialogInput" contentStyle="height: 72vh; max-height: 72vh; overflow-y: scroll;">
        <template v-slot:content>
            <p class="mx-1" v-html="notification.text"></p>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text class="myprovet-btn-ok" @click="onCloseDialog" data-cy="app-dialog-confirm-btn">{{ $t('common.close') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
export default {
    emits: ['mark-as-read'],
    props: {
        notification: Object,
    },

    data() {
        return {
            privacyPolicy: null,
        };
    },

    methods: {
        onCloseDialog() {
            this.$emit('on-cancel', false);
        },

        onDialogInput(event) {
            if (!event) {
                this.$emit('on-cancel', false);
            }
        },
    },
};
</script>
